import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const gbp = (v) => `£${Number(v).toFixed(2)}`;

export function whatsappOrderLink(items, total, orderId, fmt = gbp, gift = null) {
  const lines = items
    .map((i) => `- ${i.name}${i.variant ? ` (${i.variant})` : ""} x${i.qty} (${fmt(i.price * i.qty)})`)
    .join("\n");
  const wrap =
    gift && gift.tier && gift.tier !== "none"
      ? `Gift wrapping: ${gift.tier === "signature" ? "Gold Signature Wrapping" : "Classic Wrapping"}${
          gift.note ? `\nNote: "${gift.note}"` : ""
        }`
      : null;
  const text = [
    "Hello ATW Around The World,",
    "",
    "I would like to place this order:",
    lines,
    wrap,
    "",
    `Total: ${fmt(total)}`,
    orderId ? `Order reference: ${orderId}` : null,
  ]
    .filter((l) => l !== null)
    .join("\n");
  return `https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}
